export enum DanceManagerPayoutTransactionStatusEnum {
  'PAYOUT' = 'PAYOUT',
  'PAYMENT' = 'PAYMENT',
  'ADJUSTMENT' = 'ADJUSTMENT',
  'PAYMENT_REFUND' = 'PAYMENT_REFUND'
}
